var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"value":_vm.show,"max-width":"500"},on:{"input":(val) => _vm.outsideClick(val)}},[_c('v-card',[_c('CloseDialogButton',{attrs:{"close":_vm.closeAuth}}),_c('ResetPassword',{attrs:{"to":_vm.to}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }